import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IFinalResponse } from '_core/types';
import { HeadlessDeliveryTypes } from '../Types';

const machine = Machines.onHeadlessDelivery.machine;

export const findHeadlessDelivery = (
  params: HeadlessDeliveryTypes.HeadlessDeliveryServiceRequestType,
): Promise<IFinalResponse> => callServiceMachine(machine, params);

export default { findHeadlessDelivery };
